module.exports = __webpack_public_path__ + "static/media/6@1280w.2b1bc0e5.jpg";